import React from "react";
import { withRouter } from "react-router-dom";
import { Route, Redirect, Switch } from "react-router-dom";

import Updates from "./../Updates";
import About from "./../About";
import Ace from "./../Ace";
import Doremi from "./../Doremi";
import Koryu from "./../Koryu";
import Mickey3 from "./../Mickey3";
import Miracle from "./../Miracle";
import Debug from "./../Debug";
import Undercover from "./../Undercover";

class AppRouter extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    if (this.props.location) {
      let active = this.getRouteIndex(this.props.location.pathname);
      this.props.onChangeNavLink(active); //pass the active link back to App
    }
  }

  //get the index for the current route
  getRouteIndex(value) {
    switch (value) {
      case "/":
        return 0;
      case "/ace":
        return 1;
      case "/doremi":
        return 2;
      case "/koryu":
        return 3;
      case "/mickey3":
        return 4;
      case "/miracle":
        return 5;
      default:
        return 0;
    }
  }

  render() {
    return (
      <Switch>
        <Route path="/" exact={true} component={Updates} />
        <Route path="/about" component={About} />
        <Route path="/ace" component={Ace} />
        <Route path="/doremi" component={Doremi} />
        <Route path="/koryu" component={Koryu} />
        <Route path="/mickey3" component={Mickey3} />
        <Route path="/miracle" component={Miracle} />
        <Route path="/debug" component={Debug} />
        <Route path="/undercover" component={Undercover} />
        <Redirect from="*" to="/" />
        {/*<Route path="*" component={Updates} />*/}
      </Switch>
    );
  }
}

export default withRouter(AppRouter);



// WEBPACK FOOTER //
// ./src/lib/AppRouter.js